import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../../store/useAuthStore";
import { PAYMENT_TERMS } from "../../../constants/inventory";
import { IoArrowBack } from "react-icons/io5";

const NewVendor = () => {
  const { token } = useAuthStore();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [paymentTerms, setPaymentTerms] = useState("");
  const [leadTimeDays, setLeadTimeDays] = useState("");
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async () => {
    if (!name.trim()) {
      setErrorMessage("Vendor name is required");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch("/api/addVendor", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          name,
          contactPerson: contactPerson || undefined,
          email: email || undefined,
          phone: phone || undefined,
          address: address || undefined,
          paymentTerms: paymentTerms || undefined,
          leadTimeDays: leadTimeDays ? Number(leadTimeDays) : undefined,
          notes: notes || undefined,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        setSuccessMessage("Vendor created successfully");
        setTimeout(() => navigate("/Vendors"), 1500);
      } else {
        setErrorMessage(data.error || "Failed to create vendor");
        setTimeout(() => setErrorMessage(""), 3000);
      }
    } catch (err) {
      setErrorMessage("Failed to create vendor");
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="m-2 md:m-6 p-2 md:p-6">
      <div className="flex items-center gap-4 mb-6">
        <button
          onClick={() => navigate("/Vendors")}
          className="p-2 rounded-full hover:bg-gray-100"
        >
          <IoArrowBack className="text-xl text-primary" />
        </button>
        <h2 className="text-xl font-semibold text-gray-800">New Vendor</h2>
      </div>

      {errorMessage && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
          {errorMessage}
        </div>
      )}
      {successMessage && (
        <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg mb-4">
          {successMessage}
        </div>
      )}

      <div className="bg-white rounded-lg shadow p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="block font-medium mb-2 text-blue-500">
              Vendor Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="e.g., ABC Suppliers"
            />
          </div>
          <div>
            <label className="block font-medium mb-2 text-blue-500">
              Contact Person
            </label>
            <input
              type="text"
              value={contactPerson}
              onChange={(e) => setContactPerson(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Contact person name"
            />
          </div>
          <div>
            <label className="block font-medium mb-2 text-blue-500">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="vendor@example.com"
            />
          </div>
          <div>
            <label className="block font-medium mb-2 text-blue-500">
              Phone
            </label>
            <input
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Phone number"
            />
          </div>
          <div>
            <label className="block font-medium mb-2 text-blue-500">
              Payment Terms
            </label>
            <select
              value={paymentTerms}
              onChange={(e) => setPaymentTerms(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select Payment Terms</option>
              {PAYMENT_TERMS.map((term) => (
                <option key={term.id} value={term.id}>
                  {term.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block font-medium mb-2 text-blue-500">
              Lead Time (Days)
            </label>
            <input
              type="number"
              min="0"
              value={leadTimeDays}
              onChange={(e) => setLeadTimeDays(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="e.g., 7"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block font-medium mb-2 text-blue-500">
              Address
            </label>
            <input
              type="text"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Vendor address"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block font-medium mb-2 text-blue-500">
              Notes
            </label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              rows={3}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Additional notes..."
            />
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={() => navigate("/Vendors")}
            className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-4 py-2 bg-primary text-white rounded-lg text-sm hover:opacity-90 disabled:opacity-50"
          >
            {loading ? "Creating..." : "Save Vendor"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewVendor;
